module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_vm._l((_vm.value), function(value, key) {
    return [(value instanceof Object) ? [_c('div', {
      staticClass: "object-line"
    }, [_c('span', {
      staticClass: "object-key"
    }, [_vm._v(_vm._s(key))])]), _vm._v(" "), _c('object-dump', {
      attrs: {
        "value": value
      }
    })] : _c('div', {
      staticClass: "object-line"
    }, [_c('span', {
      staticClass: "object-key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('span', {
      staticClass: "object-value"
    }, [_vm._v(_vm._s(value))])])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-369e1999"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/form/ObjectDump.vue
// module id = 159
// module chunks = 1